import React, { useContext, useState } from 'react'
import logo from '../assets/signin.gif'
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { Link, useNavigate } from 'react-router-dom';
import SummaryApi from '../common';
import {toast} from 'react-toastify'
import Context from '../context';

const Login = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [data, setData] = useState({
        email: "",
        password: ""
    })
    const navigate = useNavigate();
    const { fetchUserDetails, fetchUserAddToCart } = useContext(Context)

    const handleOnChange = (e) =>{
        const {name, value} = e.target

        setData((prev)=>{
            return {
                ...prev,
                [name]: value
            }
        })
    }
    const handleSubmit = async (e) =>{
        e.preventDefault();

        const dataResponse = await fetch(SummaryApi.signIn.url, {
            method:SummaryApi.signIn.method,
            credentials: 'include',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        })

        const dataApi = await dataResponse.json()
        if(dataApi.success){
            toast.success(dataApi.message)
            navigate("/")
            fetchUserDetails()
            fetchUserAddToCart()
        }
        if(dataApi.error){
            toast.error(dataApi.message)
        }
    }
    console.log("Data login", data)


  return (
    <section id='login' className='mt-2'>
        <div>

            <div className='bg-white p-4 w-full max-w-sm mx-auto'>
                <div className='w-20 h-20 mx-auto'>
                    <img src={logo} alt='signIn'/>
                </div>

                <form className='pt-6 flex flex-col gap-2' onSubmit={handleSubmit}>
                    <div className='grid'>
                        <label>Email: </label>
                        <div className='bg-slate-100 p-2'>
                            <input 
                                type='email' 
                                placeholder='Enter your email' 
                                name='email'
                                value={data.email}
                                onChange={handleOnChange}
                                className='w-full h-full outline-none bg-transparent'/>
                        </div>
                    </div>
                    <div>
                        <label>Password: </label>
                        <div className='bg-slate-100 p-2 flex'>
                            <input 
                                type={showPassword ? "text":"password"} 
                                placeholder='Enter password' 
                                name='password'
                                value={data.password}
                                onChange={handleOnChange}
                                className='w-full h-full outline-none bg-transparent'/>
                            <div className='cursor-pointer text-xl' onClick={()=> setShowPassword((prev) => !prev)}>
                                <span>
                                    {showPassword ? (<FaEyeSlash/>) : (<FaEye/>)}
                                </span>
                            </div>
                        </div>
                        <Link to={"/forgot-password"} className='block w-fit ml-auto hover:underline hover:text-red-600'>Forgot password ?</Link> 
                    </div>

                    <button className='bg-red-600 text-white px-6 py-2 w-full max-w-[150px] rounded-full hover:bg-red-700 mx-auto block mt-6'>Login</button>
                </form>

                <p className='my-5'>Didn't have an account? <Link to={"/sign-up"} className='text-red-500 hover:text-red-700 hover:underline'>Sign Up</Link></p>
            </div>
        </div>
    </section>
  )
}

export default Login